import { useMutation } from "@tanstack/react-query"
import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "../../../components/ui/collapsible/Collapsible"
import styles from "./thread.module.css"
import { authApi } from "../../../api/authMutation/authApi"
import { useForm } from "react-hook-form"
import { Button } from "../../../components/ui/button/Button"
import { queryClient } from "../../../api/queryClient"
import { useUserStore } from "../../../stores/useUserStore"
export function Thread({ thread }) {
    const { user } = useUserStore();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    const { mutate, error, isPending } = useMutation({
        mutationFn: (questionData) => {


            return authApi.comment(questionData, thread.id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['threads'] })
            reset()
        }
    })
    function formatDateNative(inputDate) {

        return new Date(inputDate).toLocaleDateString('ru-RU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        });
    }



    const onSubmit = (data) => {
        mutate(data);
    };

    const copyThread = thread

    return (
        <div className={styles.thread}>
            <Collapsible className={styles.collapsible}>
                <CollapsibleTrigger className={styles.collapsibleTrigger}>
                    <div className={styles.title}>{thread.text}</div>
                    <div className={styles.info}>
                        <span className={styles.author}>{thread.author}</span>
                        <span className={styles.date}>{formatDateNative(thread.created_at)}</span>
                    </div>
                </CollapsibleTrigger>


                <CollapsibleContent className={styles.collapsibleContent}>
                    <div className={styles.answers}>
                        {copyThread?.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((item) => (
                            <div key={item.id} className={`${styles.answer} ${item.is_staff ? styles.staff : ""}`}>
                                <div className={styles.title}>Ответ {item.is_staff ? "специалиста" : "пользователя"}</div>
                                <p className={styles.text}>{item.text} </p>
                                <div className={styles.info}>
                                    <span className={styles.author}>{item.author}</span>
                                    <span className={styles.date}>{formatDateNative(item.created_at)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                        <div className={styles.formGroup}>
                            <div>
                                <input id='author' className={`${styles.input} ${errors.author && styles.errorInput}`} type="text" placeholder='Введите ваше имя' {...register('author', {
                                    required: 'Это поле обязательно',
                                    minLength: {
                                        value: 2,
                                        message: 'Минимум 2 символа'
                                    }
                                })} />
                                {(errors?.author || error) && (
                                    <span className={styles.error}>
                                        {errors?.author?.message || error?.message || "Непредвиденная ошибка"}
                                    </span>
                                )}
                                <div className={styles.input_wrapper}>
                                    <textarea
                                        placeholder="Введите ваш комментарий"
                                        className={`${styles.input} ${errors.text && styles.errorInput}`}
                                        {...register('text', { required: 'Это поле обязательно' })}
                                    />
                                    {(errors.text || error) && (
                                        <span className={styles.error}>
                                            {errors.text?.message || error?.message || "Непредвиденная ошибка"}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div>
                            <Button disabled={isPending} type="submit" variant={'dark-blue'}>
                                Оставить комментарий
                            </Button>

                        </div>
                    </form>
                </CollapsibleContent>
            </Collapsible>

        </div>
    )
}
